// base
import React, { useEffect, useState } from 'react';

// contexts
import { PkgContext } from 'contexts';

// layouts
import { SEOMetaTag } from 'layouts';

// constants
import { PKG_2, PKG_4 } from 'constants/const';

// services
import { cookieStorage, COOKIE_PKG } from 'services';

export type PkgProviderProps = React.PropsWithChildren<{}>;

export const PkgProvider: React.FC<PkgProviderProps> = ({ children }) => {
  const [pkgNo, setPkgNo] = useState<string | null>(null);

  useEffect(() => {
    const pkgNumber = cookieStorage.getCookie(COOKIE_PKG);

    const getPkgType = () => {
      const hostname = window?.location?.hostname || '';

      // GS 운영계 + 개발계
      if (
        hostname.includes('fgip2') ||
        hostname.includes('4s-rfid.com') ||
        hostname.includes('pkg2')
      ) {
        return PKG_2;
      }

      // if (hostname.includes('fgiprfid.com')) {
      //   return PKG_4;
      // }

      return pkgNumber || PKG_4;
    };

    const newPkgNo = getPkgType();

    if (pkgNumber && pkgNumber === newPkgNo) {
      setPkgNo(pkgNumber);
      console.log(`%c 4S PKG No : ${pkgNumber} `, 'background: #222; color: #bada55');
      console.log(`%c Platform : ${window.location.href} `, 'background: #222; color: #bada55');
      return;
    }

    setPkgNo(newPkgNo);
    cookieStorage.setCookie(COOKIE_PKG, newPkgNo);

    console.log(`%c 4S PKG No : ${newPkgNo} `, 'background: #222; color: #bada55');
    console.log(`%c Platform : ${window.location.href} `, 'background: #222; color: #bada55');
  }, []);

  return (
    <PkgContext.Provider
      value={{
        pkgNo,
        setPkgNo
      }}
    >
      {pkgNo && <SEOMetaTag pkgNo={pkgNo} />}
      {children}
    </PkgContext.Provider>
  );
};
